<script setup lang="ts">
defineProps<{
  overline?: string | null
  title: string
  abstract: string
}>()
</script>

<template>
  <div class="bg-gradient-nugget rounded-3xl p-8 md:p-12 mb-8">
    <div v-if="overline" class="text-sm md:text-base font-medium uppercase tracking-widest mb-4 opacity-80">
      {{ overline }}
    </div>
    <h1 class="text-h2 mb-8 leading-tight">
      {{ title }}
    </h1>
    <div class="text-lg md:text-xl leading-relaxed" v-html="abstract">
    </div>
  </div>
</template>
